/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Auth_Error_DescriptionInputs */

const en_meta_auth_error_description = /** @type {(inputs: Meta_Auth_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't finish signing you in. Try again or use your email address.`)
};

const es_meta_auth_error_description = /** @type {(inputs: Meta_Auth_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos completar tu inicio de sesión. Inténtalo de nuevo o usa tu correo electrónico.`)
};

/**
* | output |
* | --- |
* | "We couldn't finish signing you in. Try again or use your email address." |
*
* @param {Meta_Auth_Error_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_auth_error_description = /** @type {((inputs?: Meta_Auth_Error_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Auth_Error_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_auth_error_description(inputs)
	return en_meta_auth_error_description(inputs)
});